import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

const PHONE = "15197029417";
const DEFAULT_MSG =
  "Hi Yach Construction — I'd like to enquire about a project.";

export default function FloatingWhatsApp({ message = DEFAULT_MSG }) {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, duration: 0.6, ease: [0.65, 0, 0.35, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      className="fixed z-40 bottom-6 right-6 md:bottom-8 md:right-8 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <span className="relative flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_-6px_rgba(37,211,102,0.65)]">
        <MessageCircle className="w-5 h-5" strokeWidth={2.2} />
        <span className="font-grotesk text-[12px] uppercase tracking-[0.2em] hidden sm:inline">
          Chat
        </span>
      </span>
    </motion.a>
  );
}
